import React, { Component } from 'react';
import { Form as ImportForm } from 'semantic-ui-react';
import excludeKeys from '../../../../../utils/excludeKeys';

class FormTextArea extends Component {
  render() {
    return (
      <ImportForm.TextArea {...excludeKeys(this.props)} />
    );
  }
}

export default FormTextArea;
